import { PlusOutlined } from "@ant-design/icons";
import {
	Button,
	Card,
	Col,
	Form,
	Input,
	Row,
	Select,
	Typography,
	Upload,
	Radio,
	Table
} from "antd";
import { toast } from "react-toastify";

import { Fragment, useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { Navigate } from "react-router-dom";
import checkTokenExp from "../../utils/checkTokenExp";
import { addProduct, addRunningSize, getSingleRate } from "../../redux/actions/product/addProductAction";
import { loadAllProductBrand } from "../../redux/actions/productBrand/getProductBrandAction";
import { loadAllProductCategory } from "../../redux/actions/productCategory/getProductCategoryAction";
import { loadAllProductSubCategory } from "../../redux/actions/productSubCategory/getProductSubCategory";
import { loadAllCustomer } from "../../redux/actions/customer/getCustomerAction";
import UploadMany from "../Card/UploadMany";
import styles from "./AddProd.module.css";
import LayerSelectorBasic from "../Card/LayerSelectorBasic";
import LayerSelectorAdvance from "../Card/LayerSelectorAdvance";
import LayerTemplateSelector from "../Card/LayerTemplateSelector";
import PrintSelector from "../Card/PrintSelector";
import CoatingSelector from "../Card/CoatingSelector";
import data from '../../data/rawMaterialData'
import { buildLayersForPly } from '../../utils/layerUtils'
import { set } from "lodash";

const AddSingleRate = () => {
	const {unitType, ply, castingType} = data
	
	const yesNo = ["Yes", "No"]
	
	const layerObj = {layerId: 0, layerType: "", materialType:"", gsm:"", bf:"", ff:""};
	
	const category = useSelector((state) => state.productCategories?.list);

	const subCategory = useSelector((state) => state.productSubCategories?.list);

	const dispatch = useDispatch();

	const { Title } = Typography;
	const [fileList, setFileList] = useState([]);
	const [loader, setLoader] = useState(false);
	const [isPrinting, setIsPrinting] = useState(false)
	const [isCoating, setIsCoating] = useState(false)
	const [layers, setLayers] = useState([])
	const [layerSelector, setLayerSelector] = useState(false)
	const [gsm, setGsm] = useState([])
	const [bf, setBf] = useState([])
	const [printing, setPrinting] = useState({})
	const [coating, setCoating] = useState({coatings: []})
	const [rate, setRate] = useState({});

	const [form] = Form.useForm();

	//useEffect for loading category list from redux
	useEffect(() => {
		dispatch(loadAllProductCategory({ page: 1, limit: 20 }));
		dispatch(loadAllProductSubCategory({ page: 1, limit: 20 }));
	}, [dispatch]);

	// Check if user is logged in
	const isLogged = Boolean(localStorage.getItem("isLogged"));

	if (!isLogged) {
		return <Navigate to={"/auth/login"} replace={true} />;
	}

	// Check if token is expired
	const accessToken = localStorage.getItem("access-token");
	checkTokenExp(accessToken);

	const onFinish = async (values) => {
		console.log("The values on submit", values);
		const subcat = subCategory.filter((item) => item.name === values.subcategory)[0]
		console.log("Subcategory selected", subcat)
		try {
			let formData = {
				subcategory: values.subcategory,
				length: values.length,
				width: values.width,	
				height: values.height,
				unitType: values.unitType,
				casting: values.casting,
				quantity: values.quantity,
				ply: values.ply,
				layerSelector: layerSelector,
				layers: layers,
				isPrinting: isPrinting,
				printing: printing,
				isCoating: isCoating,
				coating: coating,
				topConversionRate: values.topConversionRate,
				boxConversionRate: values.boxConversionRate,
				numberOfPieces: subcat.sheet_size_formula
			};
			
			console.log(formData)
			const resp = await dispatch(getSingleRate(formData));

			if (resp.message === "success") {
				//form.resetFields();
				console.log("resp", resp);
				setRate(resp.data);
				setFileList([]);
				setLoader(false);
			} else {
				setLoader(false);
			}
		} catch (error) {
			console.log("The error occured: ", error.toString());
			toast.error(`error at creating: ${error.message}`);
			setLoader(false);
		}
	};

	const onFinishFailed = (errorInfo) => {
		setLoader(false);
		const firstError = errorInfo?.errorFields?.[0]?.errors?.[0] || 'Please fill all required fields';
		toast.error(firstError);
		console.log("Failed:", errorInfo);
	};

	const handelChange = ({ fileList }) => {
		setFileList(fileList);
	};

	const onClickLoading = () => {
		setLoader(true);
	};

	const handlePrintingChange = (e) => {
		if(e.target.value === 'yes'){
			setIsPrinting(true)
		}else{
			setIsPrinting(false)
		}
	}

	const handleCoatingChange = (e) => {
		if(e.target.value === 'yes'){
			setIsCoating(true)
		}else{
			setIsCoating(false)
		}
	}

	const handlePlyChange = (ply) => {
		const { layersArray, gsmArray, bfArray } = buildLayersForPly(ply, layers, layerObj);
		console.log("Layers Array: ", layersArray);
		setLayers(layersArray);
		setGsm(gsmArray);
		setBf(bfArray);
	}

	const handleSelectorChange = (e) => {
		if(e.target.value === 'advance'){
			setLayerSelector(true)
		}else{
			setLayerSelector(false)
		}
	}



	return (
	<Fragment>
		<Row className='mr-top' justify='space-between' gutter={[0, 30]}>
			<Col
				xs={24}
				sm={24}
				md={24}
				lg={24}
				xl={24}
				className='rounded column-design'
			>
				
				<Form
					form={form}
					name='basic'
					labelCol={{
						span: 7,
					}}
					labelWrap
					wrapperCol={{
						span: 16,
					}}
					initialValues={{
						remember: true,
						layerSelector: 'basic',
						print_selector: 'no',
						isCoating: 'no',
					}}
					onFinish={onFinish}
					onFinishFailed={onFinishFailed}
					autoComplete='off'
				>
					<Row className='mr-top' justify='space-evenly' gutter={[0, 30]}>
			<Col
				xs={24}
				sm={24}
				md={24}
				lg={10}
				xl={10}
				className='rounded column-design'
			>
				<Card bordered={false}>
				<Title level={4} className='m-2 text-center'>
					Sizing
				</Title>
			
				{/* <Form.Item
						style={{ marginBottom: "15px" }}
						label='Name'
						name='name'
					rules={[
						{
							required: false,
							message: "Please input Product name!",
						},
					]}>
					<Input />
				</Form.Item> */}

				<Form.Item
					style={{ marginBottom: "15px" }}
					name='subcategory'
					label='Subcategory '
					rules={[
						{
							required: true,
							message: "Please select sub-category!",
						},
					]}>
					<Select
						name='subcategory'
						loading={!subCategory}
						showSearch
						placeholder='Select Subcategory'
						optionFilterProp='children'
						filterOption={(input, option) =>
							option.children.includes(input)
						}
						filterSort={(optionA, optionB) =>
							optionA?.children
								.toLowerCase()
								.localeCompare(optionB?.children.toLowerCase())
						}>
						{subCategory &&
							subCategory.map((subcat) => (
								//console.log("subcat", subcat), -> Good concept
								<Select.Option key={subcat.id} value={subcat.name}>
									{subcat.name}
								</Select.Option>
							))}
					</Select>
				</Form.Item>

				{/* <Form.Item
					style={{ marginBottom: "15px" }}
					name='customer'
					label='Customer'
					rules={[
						{
							required: true,
							message: "Please select customer!",
						},
					]}>
					<Select
						name='customer'
						loading={!customer}
						showSearch
						placeholder='Select Customer'
						optionFilterProp='children'
						filterOption={(input, option) =>
							option.children.includes(input)
						}
						filterSort={(optionA, optionB) =>
							optionA?.children
								.toLowerCase()
								.localeCompare(optionB?.children.toLowerCase())
						}>
						{customer &&
							customer.map((cust) => (
								<Select.Option key={cust.id} value={cust.id}>
									{cust.name}
								</Select.Option>
							))}
					</Select>
				</Form.Item> */}

				<Form.Item
					style={{ marginBottom: "15px" }}
					label='Length'
					name='length'
					rules={[
						{
							required: true,
							message: "Please input length!",
						},
					]}>
					<Input type='number' />
				</Form.Item>

				<Form.Item
					style={{ marginBottom: "15px" }}
					label='Width'
					name='width'
					rules={[
						{
							required: true,
							message: "Please input width!",
						},
					]}>
					<Input type='number' />
				</Form.Item>

				<Form.Item
					style={{ marginBottom: "15px" }}
					label='Height'
					name='height'
					rules={[
						{
							required: true,
							message: "Please input height!",
						},
					]}>
					<Input type='number' />
				</Form.Item>


				<Form.Item
					style={{ marginBottom: "15px" }}
					name='unitType'
					label='Unit'
					rules={[
						{
							required: true,
							message: "Please select unit type!",
						},
					]}>
					<Select
						name='unitType'
						loading={!unitType}
						showSearch
						placeholder='Unit'
						optionFilterProp='children'
						filterOption={(input, option) =>
							option.children.includes(input)
						}
						filterSort={(optionA, optionB) =>
							optionA?.children
								.toLowerCase()
								.localeCompare(optionB?.children.toLowerCase())
						}>
						{unitType &&
							unitType.map((unit) => (
								<Select.Option key={unit} value={unit}>
									{unit}
								</Select.Option>
							))}
					</Select>
				</Form.Item>

				<Form.Item
					style={{ marginBottom: "15px" }}
					name='casting'
					label='Casting'
					rules={[
						{
							required: true,
							message: "Please select casting!",
						},
					]}>
					<Select
						name='casting'
						loading={!castingType}
						showSearch
						placeholder='Casting'
						optionFilterProp='children'
						filterOption={(input, option) =>
							option?.children.includes(input)
						}
						filterSort={(optionA, optionB) =>
							optionA?.children
								.toLowerCase()
								.localeCompare(optionB?.children.toLowerCase())
						}>
						{castingType &&
							castingType.map((casting, i) => (
								<Select.Option key={i+1} value={casting.value}>
									{casting.name}
								</Select.Option>
							))}
					</Select>
				</Form.Item>

				<Form.Item
					style={{ marginBottom: "15px" }}
					label='Quantity'
					name='quantity'
					rules={[
						{
							required: true,
							message: "Please input Quantity!",
						},
					]}>
					<Input type='number' />
				</Form.Item>


				<Form.Item
					style={{ marginBottom: "15px" }}
					label='Top Conversion Rate /Kg'
					name='topConversionRate'
					rules={[
						{
							required: true,
							message: "Please input top conversion rate!",
						},
					]}
					>
					<Input type='number' />
				</Form.Item>

				<Form.Item
					style={{ marginBottom: "15px" }}
					label='Box Conversion Rate /Kg'
					name='boxConversionRate'
					rules={[
						{
							required: true,
							message: "Please input box conversion rate!",
						},
					]}
					>
					<Input type='number' />
				</Form.Item> 

				{/*<Form.Item label='Upload Image' valuePropName='image'>
					<Upload
						listType='picture-card'
						beforeUpload={() => false}
						name='image'
						fileList={fileList}
						maxCount={1}
						onChange={handelChange}>
						<div>
							<PlusOutlined />
							<div
								style={{
									marginTop: 8,
								}}>
								Upload
							</div>
						</div>
					</Upload>
				</Form.Item> */}
			
				</Card>
			</Col>
			
			
			<Col
				xs={24}
				sm={24}
				md={24}
				lg={14}
				xl={14}
				className='rounded column-design'
			>
		<Card bordered={false}>
			<Title level={4} className='m-2 text-center'>
				Customization
			</Title>
			
				<Form.Item
					style={{ marginBottom: "15px" }}
					name='ply'
					label='Ply/ Walls'
					rules={[
						{
							required: true,
							message: "Please select plys!",
						},
					]}>
					<Select
						name='ply'
						loading={!category}
						showSearch
						placeholder='Ply/ Walls'
						optionFilterProp='children'
						filterOption={(input, option) =>
							option.children.includes(input)
						}
						filterSort={(optionA, optionB) =>
							optionA?.children
								.toLowerCase()
								.localeCompare(optionB?.children.toLowerCase())
						}
						onChange={handlePlyChange}>
						{ply &&
							ply.map((ply) => (
								<Select.Option key={ply.value} value={ply.value}>
									{ply.name}
								</Select.Option>
							))}
					</Select>
				</Form.Item>

				<LayerTemplateSelector
					ply={layers.length}
					layers={layers}
					setLayers={setLayers}
					gsm={gsm}
					setGsm={setGsm}
					bf={bf}
					setBf={setBf}
				/>

				<Form.Item
					rules={[
						{
							required: true,
							message: "Pleases Select Type!",
						},
					]}
					label='Layer Selector'
					name="layerSelector"
					style={{ marginBottom: "15px" }}
				>
					<Radio.Group onChange={handleSelectorChange}> 
						<Radio value='basic'>Basic</Radio>
						<Radio value='advance'>Advance</Radio>
					</Radio.Group>
				</Form.Item>

				{!layerSelector ? <LayerSelectorBasic layers={layers} setLayers={setLayers} layerSelector={layerSelector}/> : <LayerSelectorAdvance layers={layers} gsm ={gsm} bf={bf} setLayers={setLayers} setGsm={setGsm} setBf={setBf} layerSelector={layerSelector}/>}
				
				<Form.Item
					// rules={[
					// 	{
					// 		required: true,
					// 		message: "Pleases Select If Printing Required!",
					// 	},
					// ]}
					label='Printing'
					name={"print_selector"}
					style={{ marginBottom: "15px" }}
				>
					<Radio.Group onChange={e => handlePrintingChange(e)}>
						<Radio value='yes'>Yes</Radio>
						<Radio value='no'>No</Radio>
					</Radio.Group>
				</Form.Item>
				
				{isPrinting? <PrintSelector printing={printing} setPrinting={setPrinting} isPrinting={isPrinting} />: <></> }
				
				

				<Form.Item
					// rules={[
					// 	{
					// 		required: true,
					// 		message: "Please Select Coating!",
					// 	},
					// ]}
					label='Coating'
					name={"isCoating"}
					style={{ marginBottom: "15px" }}
				>
					<Radio.Group onChange={handleCoatingChange}>
						<Radio value='yes'>Yes</Radio>
						<Radio value='no'>No</Radio>
					</Radio.Group>
				</Form.Item>

				{isCoating? <CoatingSelector coating={coating} setCoating={setCoating} isCoating={isCoating} /> : <></>}

				
				{/* <Form.Item label='Upload Image' valuePropName='image'>
					<Upload
						listType='picture-card'
						beforeUpload={() => false}
						name='image'
						fileList={fileList}
						maxCount={1}
						onChange={handelChange}>
						<div>
							<PlusOutlined />
							<div
								style={{
									marginTop: 8,
								}}>
								Upload
							</div>
						</div>
					</Upload>
				</Form.Item>  */}

				
				
				<Form.Item
					style={{ marginBottom: "15px" }}
					className={styles.addProductBtnContainer}>
					<Button
						type='primary'
						htmlType='submit'
						shape='round'
						loading={loader}
						onClick={onClickLoading}>
						Calculate Rate
					</Button>
				</Form.Item>

				<Form.Item
					style={{ marginBottom: "15px" }}
					className={styles.addProductBtnContainer}>
					<Button
						type='primary'
						htmlType=''
						shape='round'
						loading={loader}
						onClick={() => {
							form.resetFields()
							setRate({})
						}
						}>
						Reset Fields
					</Button>
				</Form.Item>
			</Card>
			</Col>
		
		
		
		 {/* <Col xs={24} sm={24} md={24} lg={11} xl={11} className=' rounded'>
			<Card className={`${styles.importCsvCard} column-design`}>
				<Title level={4} className='m-2 text-center'>
					Import From CSV
				</Title>
				<UploadMany urlPath={"product"} />
			</Card>
		</Col> */}
					</Row>
				</Form>
				
			</Col>
		</Row>
		<Row className='mr-top' justify='space-between' gutter={[0, 30]}>
		<div className='mr-top'>
				{rate ? (
					<Fragment key="1">
						<Card bordered={false} className='card-custom'>
							<Row className='d-flex justify-content-between'>
								<Col xs={24} lg={24}>
									<div className='card-body ms-2'>
										<h5>Rate Calculation :</h5>
										<p>
											<Typography.Text strong>Net Rate:</Typography.Text>{" "}
											{rate?.finalRate || 0}
										</p>
										<p>
											<Typography.Text strong>Sheet Size (RS X CS):</Typography.Text>{" "}
											{rate?.RS} X {rate?.CS}
										</p>
										<p>
											<Typography.Text strong>No of Sheets :</Typography.Text>{" "}
											{rate?.N}
										</p>
										<p>
											<Typography.Text strong>Boxes per Sheet :</Typography.Text>{" "}
											{rate?.M}
										</p>
										<p>
											<Typography.Text strong>Net GSM :</Typography.Text>{" "}
											{rate?.NET_GSM}
										</p>
										<p>
											<Typography.Text strong>Box Weight (Kgs):</Typography.Text>{" "}
											{rate?.boxWeight || 0}
										</p>

										<p>
											<Typography.Text strong>Net Fixed Cost :</Typography.Text>{" "}
											{rate?.netFixedCost || 0}
										</p>
										
										<h5> Detailed Rate Breakup :</h5>
										
										{(() => {
											const topRate = rate?.topRate || 0;
											const restRate = rate?.restRate || 0;
											const printRate = rate?.printRate || 0;
											const fixedCost = rate?.fixedCostPerBox || 0;
											const laminationRate = rate?.laminationRate || 0;
											const leafingRate = rate?.leafingRate || 0;
											const spotUvRate = rate?.spotUvRate || 0;

											const rateData = [
												{ key: 1, parameter: "Top Layer Rate", value: topRate, total: topRate},
												{ key: 2, parameter: "Rest Layers Rate", value: restRate, total: topRate + restRate},
												{ key: 3, parameter: "Printing Cost", value: printRate, total: topRate + restRate + printRate},
												{ key: 4, parameter: "Fixed Cost", value: fixedCost, total: topRate + restRate + printRate + fixedCost},
												{ key: 5, parameter: "Lamination Rate", value: laminationRate, total: topRate + restRate + printRate + fixedCost + laminationRate},
												{ key: 6, parameter: "Leafing Rate", value: leafingRate, total: topRate + restRate + printRate + fixedCost + laminationRate + leafingRate},
												{ key: 7, parameter: "Spot Uv Rate", value: spotUvRate, total: topRate + restRate + printRate + fixedCost + laminationRate + leafingRate + spotUvRate},
												{ key: 8, parameter: "Net Rate", value: rate?.finalRate || 0, total: rate?.finalRate || 0},
											];

											const columns = [
												{
													title: 'Rate Components',
													dataIndex: 'parameter',
													key: 'parameter',
													width: '40%',
												},
												{
													title: 'Piecewise Rate',
													dataIndex: 'value',
													key: 'value',
													width: '30%',
													render: (value) => `₹${value.toFixed(2)}`,
												},
												{
													title: 'Total Rate',
													dataIndex: 'total',
													key: 'total',
													width: '30%',
													align: 'right',
													render: (total) => `₹${total.toFixed(2)}`,
												}
											];

											return (
												<Table 
													dataSource={rateData} 
													columns={columns} 
													pagination={false}
													size="small"
													bordered
												/>
											);
										})()}
									</div>
								</Col>

								<Col xs={24} lg={12}>
									<div className='card-body ms-2'>
										{/* <h5> Customization Information :</h5> */}
										{/*<p>
											<Typography.Text strong>Ply :</Typography.Text>{" "}
											{rate?.ply}
										</p>
										<p>
											<Typography.Text strong>Layers :</Typography.Text>{" "}
											{JSON.parse(rate?.layers).map(layer => (
												<div>Id: {layer?.layerId} | Layer: {layer?.layerType} | Material: {layer?.materialType} | Gsm: {layer?.gsm} | Bf: {layer?.bf} | Ff: {layer?.ff || ''}</div>
											) 
											)}
										</p>
										<p>
											<Typography.Text strong>Printing :</Typography.Text>{" "}
											{rate?.is_printing ? (<div> Type: {JSON.parse(rate?.printing)?.printingType } | Colors: {JSON.parse(rate?.printing)?.printingColors } | Sides: {JSON.parse(rate.printing)?.printingSides } </div>): 'No'}
										</p>
										<p>
											<Typography.Text strong>Coating :</Typography.Text>{" "}
											{/* <div>{JSON.parse(rate.coating).coatings.map(i => <span>{i} ,</span>) }</div>
											
											{rate?.is_coating ? (<div>{JSON.parse(rate?.coating).coatings.map(i => <span>{i} ,</span>) }</div>): 'No'}
										</p> */}
										
									</div>
								</Col>
							</Row>
						</Card>
					</Fragment>
				) : 
					<></>
				}
			</div>
		</Row>
	</Fragment>
	);
};

export default AddSingleRate;


// {
//     RS: 24,
//     CS: 25.5,
//     N: 2,
//     M: 0.5,
//     NET_GSM: 540,
//     "TOP_GSM": 180,
//     "topRate": 5.330322580645162,
//     "restRate": 10.376361290322581,
//     "printRate": 22.272727272727273,
//     "coatingRate": 0,
//     "netFixedCost": 2500,
//     "selectedMachines": {
//         "Offset": {
//             "name": "Offset",
//             "width": 40,
//             "height": 28,
//             "unit": "inches",
//             "costing": {
//                 "COST_PER_EXTRA_COLOR": 600,
//                 "EXTRA_COST_PER_SPL_COLOR": 200,
//                 "MOQ": 3000,
//                 "SINGLE_COLOR_MOQ_COST": 1200,
//                 "FOUR_COLOR_MOQ_COST": 2450,
//                 "PLATE_CHARGE_PER_COLOR": 500
//             }
//         },
//         "Corrugation": {
//             "name": "Corrugation",
//             "width": 52,
//             "height": "",
//             "unit": "inches"
//         },
//         "Pasting": {
//             "name": "Pasting",
//             "width": 70,
//             "height": "",
//             "unit": "inches"
//         },
//         "Die": {
//             "name": "Die",
//             "width": 40,
//             "height": 28,
//             "unit": "inches",
//             "costing": {
//                 "REGULAR_FOLDING_CARTON": {
//                     "half": 1500,
//                     "full": 2500
//                 },
//                 "MAILER": {
//                     "full": 3500
//                 }
//             }
//         }
//     },
//     "outsourceJobs": {},
//     "finalRate": 60.706683870967744,
//     "MAX_RS": 27.5,
//     "MAX_CS": 39.5,
//     "laminationRate": 0,
//     "leafingRate": 0,
//     "spotUvRate": 0,
//     "quantity": "110"
// }